import { Box, Typography } from "@mui/material";

export default function ViewCoupon() {
    return (
        <Box>
            <Typography>View Coupon page</Typography>
        </Box>
    );
}
